module.exports = __webpack_public_path__ + "img/wz.b0f6a59e.jpg";